"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ErrorMock = void 0;
class ErrorMock {
    static SomeEntitiesNotFound(found = [], notFound = []) {
        return {
            status: 404,
            message: `Some Entities Were Not Found, found: [${found.join(', ')}], not found: [${notFound.join(', ')}]`,
        };
    }
    static call(error) {
        return Promise.reject(error);
    }
}
exports.ErrorMock = ErrorMock;
ErrorMock.BadRequest = { status: 400, message: 'BadRequest' };
ErrorMock.Unauthorized = { status: 401, message: 'Unauthorized' };
ErrorMock.Forbidden = { status: 403, message: 'Forbidden' };
ErrorMock.NotFound = { status: 404, message: 'Not Found' };
ErrorMock.Gone = { status: 410, message: 'Gone' };
ErrorMock.InternalServerError = {
    status: 500,
    message: 'Internal Server Error',
};
ErrorMock.BadGateway = { status: 502, message: 'Bad Gateway' };
ErrorMock.ServiceUnavailable = { status: 503, message: 'Service Unavailable' };
//# sourceMappingURL=error.mock.js.map